interface RadioMarkerProps {
    isSelected: boolean;
    dataTestId: string;
}

/**
 * Drawing only: the tile carries the `radio` role, and a control nested in it would be flattened by
 * ARIA. One box for both states, so choosing a tile never resizes it.
 */
export const RadioMarker = ({ isSelected, dataTestId }: RadioMarkerProps) => (
    <div
        className={`flex size-5 items-center justify-center rounded-full border-2 bg-white ${isSelected ? 'border-primary' : 'border-base-300'}`}
        data-testid={dataTestId}
    >
        <div className={`size-2.5 rounded-full ${isSelected ? 'bg-primary' : 'bg-white'}`} />
    </div>
);
